/**
 * MasterPanel.jsx — 예약 마스터 정보 패널 (Phase 2 조회 + Phase 3-B 수정 버튼, 2026-04-30)
 *
 * 표시: 회사·예약일·여행기간·인원·연락처·메모 + 자동계산 (총원가/고객지불/수익)
 * Phase 3-B: 우상단 "수정" 버튼 → MasterEditModal 열림
 */
import React, { useState } from 'react';
import MasterEditModal from './MasterEditModal';

const fmt = (n) => (n == null ? '-' : Number(n).toLocaleString('ko-KR'));
const fmtDate = (d) => (d ? String(d).slice(0, 10) : '-');

export default function MasterPanel({ master, onChanged }) {
  const [editOpen, setEditOpen] = useState(false);
  if (!master) return null;
  const totalPax = (master.adult_count||0) + (master.child_count||0) + (master.infant_count||0);
  const profit = Number(master.profit || 0);
  return (
    <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, padding: 14, display: 'grid', gap: 10 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', borderBottom: '1px solid var(--border)', paddingBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>예약 마스터</span>
        <button onClick={() => setEditOpen(true)}
          style={{ padding: '3px 10px', fontSize: 11, background: 'var(--accent-700, #7c3aed)', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
          수정
        </button>
      </div>
      {editOpen && <MasterEditModal master={master} onClose={() => setEditOpen(false)} onSaved={onChanged} />}

      <Row label="회사">{master.company_code}</Row>
      <Row label="예약일">{fmtDate(master.reservation_date)}</Row>
      <Row label="출발 — 귀국">{fmtDate(master.travel_start)} ~ {fmtDate(master.travel_end)}</Row>
      <Row label="인원">{`총 ${totalPax}명 (성인 ${master.adult_count||0} / 소아 ${master.child_count||0} / 유아 ${master.infant_count||0})`}</Row>
      <Row label="연락처">{master.customer_phone || '-'}</Row>
      <Row label="이메일">{master.customer_email || '-'}</Row>
      <Row label="경로">{master.source || '-'}</Row>
      <Row label="비고">{master.notes || '-'}</Row>

      {/* 자동계산 — view 결과 */}
      <div style={{ marginTop: 6, paddingTop: 10, borderTop: '1px solid var(--border)', display: 'grid', gap: 6 }}>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 700 }}>자동 계산 (airtel_reservation_summary)</div>
        <Row label="총원가">{fmt(master.total_cost)} 원</Row>
        <Row label="고객지불">{fmt(master.customer_paid)} 원</Row>
        <Row label="차액">{fmt(master.difference)} 원</Row>
        <Row label="수익"><span style={{ color: profit < 0 ? '#dc2626' : '#16a34a', fontWeight: 700 }}>{fmt(master.profit)} 원</span></Row>
      </div>
    </div>
  );
}

function Row({ label, children }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '70px 1fr', fontSize: 12, gap: 6 }}>
      <span style={{ color: 'var(--text-muted)' }}>{label}</span>
      <span style={{ color: 'var(--text)', wordBreak: 'break-all' }}>{children}</span>
    </div>
  );
}
